import api from "./api";
import { setAxiosHeader4Post } from "./serviceMain";

export type addOrCreateCustomer = {
    FirstName: string;
    LastName: string;
    SignInName: string;
    Email: string;
    MobilePhone: string;
    NationalIdNumber: string;
    StoreCode?: string;
    GroupId?: string;
    OverrideIdCreatorPlatformType: number;
}

export type addOrCreateCustomerResponse = {
  status: boolean;
  message: string
}

export async function addCreateCustomer(body: addOrCreateCustomer) {


  const url = '/v3/account/addOrCreateCustomer';

  let status:number = 0;
  let message: string = '';

  let messageDefault: string = 'Il cliente è già collegato a questa utenza. ' +
    'Se si sta cercando di registrarsi a una farmacia dello stesso Gruppo è comunque possibile utilizzare la propria Card all\'interno ' +
    'di tutte le farmacie del Gruppo';

  await api.post(`${url}`, JSON.stringify(body), { 
    headers: setAxiosHeader4Post(body),
    }).then((response)=> {
    status = response?.status;
    message = response?.data?.message ? response.data.message : messageDefault
  });

  return {
    status: status,
    message: message
  }

};